import Loadable from 'react-loadable'

import Loading from './components/common/RouteLoading'

const TIMEOUT = 50000
const DELAY = 500

export const Home = Loadable({
  loader: () => import('./containers/home'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const UnlockAccount = Loadable({
  loader: () => import('./containers/account/unlock'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const NewAccount = Loadable({
  loader: () => import('./containers/account/create'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const Exchange = Loadable({
  loader: () => import('./containers/exchange'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const Balances = Loadable({
  loader: () => import('./containers/balances'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const SendMobile = Loadable({
  loader: () => import('./containers/mobile/SendMobile'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const OpenOrders = Loadable({
  loader: () => import('./containers/order/openOrders'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const History = Loadable({
  loader: () => import('./containers/mobile/History'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const OrderHistory = Loadable({
  loader: () => import('./containers/order/orderHistory'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const FeesHistory = Loadable({
  loader: () => import('./containers/fees'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const TradeHistory = Loadable({
  loader: () => import('./containers/trade/tradeHistory'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const TransactionHistory = Loadable({
  loader: () => import('./containers/transaction/History'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const UnlockFromCoinomiAndRedirect = Loadable({
  loader: () => import('./containers/account/unlock/UnlockFromCoinomiAndRedirect'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const UnlockFromInfinitoAndRedirect = Loadable({
  loader: () => import('./containers/account/unlock/UnlockFromInfinitoAndRedirect'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const NoFound = Loadable({
  loader: () => import('./components/common/404'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const TradePairMobile = Loadable({
  loader: () => import('./containers/mobile/TradePairMobile'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const Terms = Loadable({
  loader: () => import('./containers/terms/terms'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const Privacy = Loadable({
  loader: () => import('./containers/terms/index'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const Token = Loadable({
  loader: () => import('./containers/token/old_list'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const TokenList = Loadable({
  loader: () => import('./containers/token/list/index'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const TokenIssuanceSelect = Loadable({
  loader: () => import('./containers/token/issue/select'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const TokenIssuance = Loadable({
  loader: () => import('./containers/token/issue'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const RecoverKeystore = Loadable({
  loader: () => import('./containers/account/recover/RecoverPhrase'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export const EditWallet = Loadable({
  loader: () => import('./containers/account/editWallet'),
  loading: Loading,
  delay: DELAY,
  timeout: TIMEOUT,
})

export default {
  Home,
  UnlockAccount,
  Exchange,
  Balances,
  OpenOrders,
  OrderHistory,
  TradeHistory,
  TransactionHistory,
  UnlockFromCoinomiAndRedirect,
  UnlockFromInfinitoAndRedirect,
  NoFound,
  TradePairMobile,
  Terms,
  Token,
  RecoverKeystore,
  EditWallet,
  Privacy,
}
